module.exports = __webpack_public_path__ + "static/media/about_piermont.d968db39.png";